import { render, staticRenderFns } from "./ApiAdressePlugin.vue?vue&type=template&id=509589fe&scoped=true"
import script from "./ApiAdressePlugin.vue?vue&type=script&lang=ts"
export * from "./ApiAdressePlugin.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./ApiAdressePlugin.vue?vue&type=style&index=0&id=509589fe&prod&scoped=true&lang=less")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "509589fe",
  null
  ,true
)

export default component.exports